import styled, { css } from "styled-components"
import { fieldStyles } from "../styles"

export const StyledDateField = styled.input`
  ${fieldStyles}
  padding: calc(0.75rem - 1px) 1.25rem;

  @supports (-webkit-touch-callout: none) {
    min-height: 3rem;
  }

  ${(props) =>
    props?.homepage &&
    css`
      padding: 12px 16px 10px 16px;
    `}

  ${(props) =>
    props?.simpleForm &&
    css`
      padding: 12px 16px 10px 16px;
    `}
`
